import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=1ebe6a59&scoped=true&"
import script from "./Dashboard.js?vue&type=script&lang=js&"
export * from "./Dashboard.js?vue&type=script&lang=js&"
import style0 from "./Dashboard.scss?vue&type=style&index=0&id=1ebe6a59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebe6a59",
  null
  
)

export default component.exports